import { render, staticRenderFns } from "./digital-quarry.vue?vue&type=template&id=7c88af5e&scoped=true"
import script from "./digital-quarry.vue?vue&type=script&lang=js"
export * from "./digital-quarry.vue?vue&type=script&lang=js"
import style0 from "./digital-quarry.vue?vue&type=style&index=0&id=7c88af5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88af5e",
  null
  
)

export default component.exports